import type { CashierAccessSummaryItem } from './types'

const time = (iso: string) => new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
/** Статус входа кассира словами и значком: цвет не единственный носитель смысла. */
export function rosterStatus(item: CashierAccessSummaryItem | undefined): string | null {
  if (item === undefined) return null
  const way = item.provider === 'native' ? 'код источника' : 'код приложения'
  const source = item.usesSourceDefault ? ' (по политике источника)' : ''
  const code = item.usesDefaultCode ? '◐ код по умолчанию — смените' : item.configured ? '● код задан' : '○ код не задан'
  const locked = item.lockedUntil === null ? '' : ` · 🔒 заперт до ${time(item.lockedUntil)}`
  return `${way}${source} · ${code}${locked}`
}
